module.exports = __webpack_public_path__ + "static/dia-site-mobile-9a3bb713b5e74407bda9b32241433ce4.jpg";